import { render, staticRenderFns } from "./TabButtons.vue?vue&type=template&id=00503d04&scoped=true"
import script from "./TabButtons.vue?vue&type=script&lang=js"
export * from "./TabButtons.vue?vue&type=script&lang=js"
import style0 from "./TabButtons.vue?vue&type=style&index=0&id=00503d04&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00503d04",
  null
  
)

export default component.exports